import "$styles/index.scss"
import "$styles/custom.scss"
import "$styles/syntax-highlighting.css"

// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}"

// Import spinning logo renderer
import "./spinning_logo/index.js"

// Import table of contents
import "./table_of_contents.js"

console.info("Bridgetown is loaded!")
